export const TABLE = {
  TAB_LABEL: 'table-tab-label',
  LINE_ARROW_DOWN: 'table-tab-arrow-down',
  NESTED_LIST_SUBHEADER: 'table-tab-selected-column-count-label',
  NEW_CODE_BUTTON_TEXT: 'table-new-code-button-text',
  NEW_CODE_NAME_INPUT: 'table-new-code-name-input',
  NEW_CODE_ADD_OPTION_INPUT: 'table-new-code-add-option-input',
  ADD_CODE_BTN: 'table-add-code-btn',
  TABLE_NAVIGATION_POPUP: 'table-contextual-menu-popup',
  TABLE_HEADER_MENU_CONTAINER: 'table-column-header-menu-container',
  MENU_TEXT: 'table-contextual-menu-item-text',
  POPUP_TITLE: 'changelog-popup-title',
  HISTORY_ASSISTED_BY: 'changelog-history-assisted-by',
  HISTORY_TEXT: 'changelog-history-text',
  NAME_CELL: 'table-element-name-cell',
  MORE_MENU: 'table-element-cell-more-menu',
  SERIAL_NUMBER_HEADER_TEXT: 'serial-number-header-text',
  SERIAL_NUMBER_HEADER_CHECKBOX: 'serial-number-header-checkbox',
  BOTTOM_NAV_MESSAGE_TEXT: 'bottom-bulk-menu-box-message-text',
  BOTTOM_NAV_RIGHT: 'bottom-bulk-menu-cancel-btn',
  BOTTOM_NAV_WRAPPER: 'bottom-bulk-menu-wrapper',
  TYPE_ID_INPUT: 'type-id-input',
  COLUMN_HEADER_TEXT: 'column-header-text',
  ADD_FIELD_COLUMN_HEADER_POPUP: 'add-field-menu-popup',
  NEW_FIELD_ICON: 'new-code-plus-icon',
  INPUT_WRAPPER: 'new-code-name-input',
  DIALOG_BTN: 'cancel-new-code-dialog-btn',
  TABLE_MENU_ITEM: 'column-header-menu-item',
  HIDE_FIELD: 'hide-field-icon',
  INSERT_COL_LEFT: 'insert-col-left-icon',
  INSERT_COL_RIGHT: 'insert-col-right-icon',
  EXISTING_FIELD: 'existing-field-icon',
  COLUMN_FIELDS_LIST: 'column-fields-list-box',
  CHANGE_BASELINE_BUTTON: 'change-baseline-version-button',
  CHANGE_COMPARISON_VERSION_DIALOG: 'change-comparison-version-dialog',
  CHANGE_COMPARISON_VERSION_DIALOG_CLOSE: 'change-comparison-version-dialog-close',
  CHANGE_COMPARISON_VERSION_BASELINE_OPTION: 'change-comparison-version-baseline-option',
  CHANGE_COMPARISON_VERSION_PREVIOUS_OPTION: 'change-comparison-version-previous-option',
  CHANGE_COMPARISON_VERSION_OTHER_OPTION: 'change-comparison-version-other-option',
  CHANGE_COMPARISON_VERSION_BROWSE_OPTION: 'change-comparison-version-browse-option',
  CHANGE_COMPARISON_VERSION_MENU_ITEM: 'change-comparison-version-menu-item',
  CHANGE_COMPARISON_VERSION_MENU_ICON: 'change-comparison-version-menu-icon',
  FIND_FIELD_INPUT: 'find-field-input',
  SWITCH_WRAP: 'column-fields-switch-toggle-wrap',
  AG_HEADER_CELL: 'ag-header-cell',
  ADD_FILTERS: 'add-filters-icon',
  CONSTRAINT_DROPDOWN_OPTION_TEXT: 'constraint-dropdown-option-text',
  ENTER_NUMBER_INPUT: 'enter-number-input',
  CONSTRAINT_CELL: 'constraint-cell',
  CREATE_NEW_OPTION_INPUT: 'table-create-new-option-input',
  EDIT_ICON: 'table-edit-icon',
  SAVE_CHANGES_BUTTON: 'save-changes-button',
  DELETE_ICON: 'table-delete-icon',
  DELETE_FIELD_BUTTON: 'table-delete-field-button',
  OPTION_CHIP: 'find-option-list',
  MORE_MENU_BUTTON: 'column-header-more-menu-button',
  EMBEDDED_RELATIONSHIPS_WRAPPER: 'relationships-box',
  SECTION_MAIN_TITLE_WRAPPER: 'relationships-box-header',
  RELATIONSHIP_SECTION_TYPOGRAPHY: 'relationship-section-related-node-text',
  SUBMENU_ITEM_DIV: 'group-level-submenu-item-text',
  COPY_LINK_TO_ELEMENT: 'table-copy-link-to-element',
  CALENDAR_COLUMN_CELL_OPTION: 'calendar-column-cell-option',
  ELEMENT_NAME_CELL_TEXT: 'element-name-cell-text',
  CREATE_NEW_OPTION_BTN: 'table-create-new-option-btn',
  CUSTOM_CODE_SEARCH_BOX: 'table-custom-code-search-box',
  DELETE_ICON_MENU: 'table-delete-icon-menu',
  MORE_MENU_ICON: 'table-more-menu-dropdown-icon',
  SORTED_ICON: 'table-sort-by-sorted-icon',
  FIELD_DROPDOWN: 'table-sort-by-field-dropdown',
  ADD_CONDITION_BTN_WRAPPER: 'table-add-another-sort-btn-wrapper',
  DD_ELEMENTS_TRUNCATED_TYPOGRAPHY: 'table-sort-by-field-dropdown-list-text',
  MUI_TREE_ITEM_LABEL: 'mui-tree-item-label',
  STRIP_BUTTON_ORGANIZE_ICON: 'table-strip-button-organize-icon',
  STRIP_BUTTON_SORTED_ICON: 'table-strip-button-sorted-icon',
  CALENDAR_SEARCH_INPUT: 'table-calendar-search-input',
  CREATE_CALENDAR_BUTTON: 'table-create-calendar-button',
  RESOURCES_LIST_WRAPPER: 'table-resources-list-wrapper',
  RESOURCE_CELL_NEW: 'table-resource-cell-item-list',
  RESOURCE_NAME: 'table-resource-name',
  RESOURCE_DELETE_ICON: 'table-resource-delete-icon',
  RESOURCE_PICKER_INPUT_ICON: 'table-resource-picker-input-icon',
  CALENDAR_MENU_LIST_ITEM: 'table-calendar-menu-list-item'
} as const;
